import { MainMobileHeaderItem, SecondaryMobileHeaderItem, MenuSettings, ScrollMobileHeaderItem, PaywallMenuDataMutam } from "./categoryHeaderMutamWrapper"
import { categoryObj } from "../../../../ynet1280/videoGalleryVerticalWidget/components/videoGalleryVerticalMutamComponenta";
import { CategoryHeaderMutamSideMenu } from "./categoryHeaderMutamSideMenu";
import { useState } from "react"
import { CategoryScrollHeaderMutam } from "./categoryScrollHeaderMutam";
import { HyperLinkBuilder, SimpleLinkRenderer } from "../../../../../commonComponents/inline/hyperLink"
import { RenderReactAtSite } from "../../../../../commonComponents/inline/renderReactAtSite";
import { ArticleMutamHeaderNewShareComponent } from "../../../../calcalist/components/articleMutamHeaderNewShareComponent";


interface CategoryHeaderMutamProps {
    mainItems: MainMobileHeaderItem[]
    secondaryItems: SecondaryMobileHeaderItem[]
    scrollItems: ScrollMobileHeaderItem[]
    category: categoryObj
    menuSettings: MenuSettings
    isArticlePage: boolean
    domain: string
    paywallMenuDataMutam: PaywallMenuDataMutam
    headerNewDesign?: boolean
}

export const CategoryHeaderMutam  = (props: CategoryHeaderMutamProps) => {
    const { mainItems, secondaryItems, scrollItems, category, menuSettings, isArticlePage, domain, paywallMenuDataMutam, headerNewDesign } = props
    const [showSideMenu, setShowSideMenu] = useState<boolean>(false)
    let selectedId = category ? category.id : "";
    const selectedCategory = mainItems.find(item => item.categoryId === selectedId) || secondaryItems.find(item => item.categoryId === selectedId)
    const overflow = showSideMenu ? "hidden" : "scroll";
    const bodyStyle = `body {overflow: ${overflow} !important;}`

    const onSideMenuBtnClick = () => {
        setShowSideMenu(!showSideMenu)
    }

    return (
      <>
      <div className={`category-header-mutam ${headerNewDesign ? "headerNewDesign" : ""}`} style={{ backgroundColor: selectedCategory && selectedCategory.bgColor ? selectedCategory.bgColor : "#d01e25" }}>
            <style>
                {bodyStyle}
            </style>
            {paywallMenuDataMutam.showPaywallMenu && <HyperLinkBuilder href={paywallMenuDataMutam.subscribeBtnLink.link} linkTarget={paywallMenuDataMutam.subscribeBtnLink.linkTarget} className="digital-edition-label">
                <span>המהדורה הדיגיטלית</span>
            </HyperLinkBuilder>}

            {!isArticlePage && <CategoryHeaderMutamSideMenu
                domain={domain}
                mainItems={mainItems}
                showSideMenu={showSideMenu}
                menuSettings={menuSettings}
                secondaryItems={secondaryItems}
                oncloseMenu={onSideMenuBtnClick}
                paywallMenuDataMutam={paywallMenuDataMutam}
            />}

            <div className="heder-title">
                {isArticlePage ? category.name : (selectedCategory && selectedCategory.categoryId !== "8" && selectedCategory.title ?
                    selectedCategory.title
                    :
                    <div className="calcalist-main-logo icon"></div>)
                }
            </div>
             {isArticlePage && <SimpleLinkRenderer href="https://calcalist.co.il" className="back-hp" title="חזרה לעמוד הבית" />}

             {!isArticlePage && <CategoryScrollHeaderMutam scrollItems={scrollItems} openHam={onSideMenuBtnClick} />}

         

        </div>
         {isArticlePage &&  <ArticleMutamHeaderNewShareComponent /> }  </>
    )
}

CategoryHeaderMutam.siteScriptName = 'CategoryHeaderMutam'
